import PropTypes from "prop-types";

function SelfServiceMobile({ config }) {
  return (
    <iframe
      width={"100%"}
      height={"100%"}
      src="https://mtrix-padsales-main.mtrix.com.br/#/self-service"
    ></iframe>
  );
}

SelfServiceMobile.defaultProps = {
  app: null,
  config: {},
};

SelfServiceMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SelfServiceMobile;
